import { useUser } from "@/context/useUser";
import ForgotPasswordResetSchema from "@/schemas/ForgotPasswordResetSchema";
import navigationRoutes from "@/utils/navigationRoutes";
import { FormItem, Input, Password, Submit } from "@formily/antd-v5";
import { createForm } from "@formily/core";
import { FormProvider, createSchemaField } from "@formily/react";
import { Card } from "antd";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const form = createForm({});

const SchemaField = createSchemaField({
  components: { FormItem, Input, Password },
});

const ForgotPasswordResetForm: React.FC = () => {
  const { forgotPasswordReset } = useUser();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: {
    newPassword: string;
    confirmPassword: string;
  }) => {
    const payload = {
      new_password: values.newPassword,
      confirm_password: values.confirmPassword,
    };
    setLoading(true);
    const response = await forgotPasswordReset(id ?? "", payload);

    if (response) {
      navigate(navigationRoutes.LOGIN);
    }
    setLoading(false);
  };

  return (
    <Card
      title="Forgot Password Reset"
      className="w-full max-w-md rounded-xl shadow-xl"
    >
      <FormProvider form={form}>
        <SchemaField schema={ForgotPasswordResetSchema} />
        <Submit
          onSubmit={handleSubmit}
          disabled={loading}
          className="w-full rounded-md px-4 py-2 text-white"
        >
          {loading ? "Resetting Password…" : "Reset Password"}
        </Submit>
      </FormProvider>
    </Card>
  );
};

export default ForgotPasswordResetForm;
